import Imageupload from './imageupload.vue';

export default Imageupload;


// WEBPACK FOOTER //
// ./src/components/inputs/imageupload/index.js